
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/follow",
      function () {
        return require("private-next-pages/follow/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/follow"])
      });
    }
  